import React from 'react'
import { Tabs, Tab, Box } from '@mui/material'
import { NavLink, Outlet, useLocation } from 'react-router-dom'
const MainPage = () => {
    const location = useLocation()
    const allTabs = [
        {
            label: 'Contact',
            value: `contact`,
        },
        {
            // label: 'Job Details',
            label: 'Group',
            value: `group`,
        },
        {
            label: 'Campaign',
            value: `campaign`,
        },
        {
            label: 'Webhook List',
            value: `webhook`,
        },
    ]
    return (
        // <section>
        //     <div className="m-t-3 cus-padd cusheight">
        //         <div>
        //             <Box sx={{ width: '100%',  }}>
        //                 <Tabs value={location.pathname}>
        //                     {allTabs.map((item, i) => (
        //                         <Tab  key={i} label={item.label} value={item.value} component={NavLink} to={item.value}
        //                         sx={{ color: "inherit", "&.active": { color: "#1976D2",borderBottom:'2px solid #1976D2',"&:hover": { color: "red" }, } }}
        //                         />
        //                     ))}
        //                 </Tabs>
        //                 </Box>
        //             <Outlet />
        //         </div>
        //     </div>
        // </section>
        <section>
        <div className="m-t-3 cus-padd cusheight">
          <div>
            <Box sx={{ width: "100%" }}>
              <Tabs value={location.pathname} textColor="primary" indicatorColor="primary">
                {allTabs.map((item, i) => (
                  <Tab
                    key={i}
                    label={item.label}
                    value={item.value}
                    component={NavLink}
                    to={item.value}
                    sx={{
                        color: "inherit", // Ensures default text color remains
                        "&.active": { 
                          color: "#1976D2", // Active tab color
                          borderBottom: "2px solid #1976D2", // Underline for active tab
                        },
                        "&:hover": { 
                          color: "#00000099", // Hover effect
                        },
                      }}
                  />
                ))}
              </Tabs>
            </Box>
            <Outlet />
          </div>
        </div>
      </section>

    )
}

export default MainPage